import {
    Alert as YotiAlert,
    AlertProps as YotiAlertProps,
} from '@yoti/ui-kit-components-react/alert';
import React, { useEffect } from 'react';
import styles from './alert.module.scss';

export interface AlertProps {
    message: string;
    variation: YotiAlertProps['variation'];
    icon: boolean;
    delay?: number;
    header?: string;
}

export interface Props extends AlertProps {
    id: string;
    onTimeout: (key: string) => void;
}

const DEFAULT_DELAY = 5000;

const Alert: React.FC<Props> = ({ id, message, variation, icon, delay, header, onTimeout }) => {
    useEffect(() => {
        const timeoutId = setTimeout(() => onTimeout(id), delay ? delay : DEFAULT_DELAY);
        return () => {
            clearTimeout(timeoutId);
        };
    }, [delay, onTimeout, id]);

    return (
        <div className={styles['alert']}>
            <YotiAlert icon={icon} heading={header} variation={variation} size="small">
                <span data-qa="msg-text">{message}</span>
            </YotiAlert>
        </div>
    );
};

export default Alert;
